import { normalizeTrackingValue } from '../utils';

import { substituteFormName } from './form-interaction';

import type { FormError } from '../types';

export const createFormErrorEvent = (args: {
  formName: string;
  message: string | string[];
}): FormError => {
  const { formName, message } = args;

  const messages = Array.isArray(message) ? message : [message];

  return {
    event_name: 'form-error',
    form_name: substituteFormName(formName),
    error_displayed_message: messages
      .map(m => normalizeTrackingValue(m))
      .join(';'),
  };
};

export const createFormErrorEventFromFieldErrors = (args: {
  formName: string;
  errors: Record<string, string | undefined> | undefined;
}) => {
  if (typeof args.errors === 'undefined') {
    return undefined;
  }

  const messages = Object.values(args.errors).filter(
    (message): message is string => typeof message === 'string',
  );

  if (messages.length === 0) {
    return undefined;
  }

  return createFormErrorEvent({
    formName: args.formName,
    message: messages,
  });
};
